
const ClientsVideo = {

	/**
	 *
	 * @param {HTMLElement} element
	 */
	init: function (element) {

		const image = element.querySelector('img');
		const svg = element.querySelector('svg');
		const video = element.querySelector('video');

		if (!video) {
			return;
		}

		video.addEventListener('play', function () {
			if (image) {
				image.classList.add('d-none');
			}
			if (svg) {
				svg.classList.add('d-none');
			}
		});

	},

};

export default ClientsVideo;
